import React from 'react';
import {Tag} from 'antd';

import fetch from './../fetch';
import utils from './../../utils';


const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'orgName', 
        label: '部门名称'
    },
    {
        key:'objName', 
        label: '诊改对象', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'resultScore', 
        label: '最终分数', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    // {
    //     key:'targetName', 
    //     label: '指标',
    //     width: 120,
    //     render: (value) => {
    //         return <label title={value}>{value}</label>
    //     }
    // },
    // {
    //     key: 'resultState',
    //     label: '诊改状态',
    //     render: (val) => {
    //         if(val === 1) {
    //             return <Tag color='blue'>未提交</Tag>
    //         } else if(val === 2) {
    //             return <Tag color='purple'>录入审核中</Tag> 
    //         } else if(val === 3) {
    //             return <Tag color='red'>录入审核不通过</Tag>
    //         } else if(val === 4) {
    //             return <Tag color='purple'>待考核或待审核</Tag>
    //         } else if(val === 5) {
    //             return <Tag color='red'>考核审核不通过</Tag>
    //         } else if(val === 6) {
    //             return <Tag color='green'>考核审核通过</Tag>
    //         }
    //     }
    // },
    // {
    //     key:'submitEmployeeName', 
    //     label: '录入人',
    //     width: 120,
    //     render: (value) => {
    //         return <label title={value}>{value}</label>
    //     }
    // },
    // {
    //     key:'entryApprovalEmployeeName', 
    //     label: '录入审核人',
    //     width: 120,
    //     render: (value) => {
    //         return <label title={value}>{value}</label>
    //     }
    // },
    // {
    //     key:'examinationApprovalEmployeeName', 
    //     label: '考核审核人',
    //     width: 120,
    //     render: (value) => {
    //         return <label title={value}>{value}</label>
    //     }
    // },
    // {
    //     key: 'submitTime', 
    //     label: '录入时间'
    // },
    {
        key:'termName', 
        label: '所属学期'
    }
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zyzgview/generalview?' + params.join('&'),  Object.assign(defaultsParams, keywords))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const remove = (ids) => {
    return fetch.post('zyzgview/delete' , ids)
    .then(response => {
        return response.payload.data;
    })
    // return new Promise((resolve, reject) => {
    //     resolve({
    //         code: 200
    //     })
    // });
    // 如果要换成可用的接口，把下面的注释打开，把地址换成 api 即可。
    // return fetch.post(`zyzgevalresulttarget/delete/${id}`)
}

const getDetailByObjId = (keywords) => {
    return fetch.get('zyzgview/getdetailbyobjid/' + keywords.id + "/" + keywords.termId)
    .then(res => {
        
        // const resultState = res.payload.meta.extParams.resultState;
        // const resultScore = res.payload.meta.extParams.resultScore;
        // const isAdmin = res.payload.meta.extParams.isAdmin;
        // const description = res.payload.meta.extParams.description;
        const count = res.payload.meta.extParams.count;
        const descList = res.payload.meta.extParams.descList;
        const dataList = res.payload.data
        const newDataList = dataList.map(d => {
            return {
                id: d.id,
                pid: d.pid,
                label: d.name,
                children: d.items.map(item => {
                    return {
                        // id: item.subId,
                        id: item.evalResultSubId,
                        pid: item.pid,
                        erId: item.evalResultId,
                        label: item.name,
                        type: item.type,
                        isSelect: item.isSelect,
                        desc: item.desc,
                        details: item.detail,
                        standard: item.evaluationStandard,
                        evaluation: item.evaluation,
                        fileList: item.fileList || [],
                        approval: item.approval, 
                        score: (item.score !== undefined || item.score !== null) ? item.score : undefined,
                        finalScore : (item.finalScore !== undefined || item.finalScore !== null) ? item.finalScore : undefined,
                    }
                })
            }
        });
        return {
            // isAdmin,
            // description,
            dataList: newDataList,
            count ,
            descList 
            // resultState,
            // resultScore
        }
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};
        var descs = {};
        var keys = [];
        var choices = {};
        response.dataList.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            let must = row.children;
            if(must && must.length > 0) {
                must.forEach(child => {
                    var childId = "C" + child.id;
                    parents[childId] = "P" + child.pid;
                    scores[childId] = child;
                    descs[childId] = child.desc;
                    keys.push(childId);
                });
            }

        });
        // scores 存的是每个依据，也就是每个item。C4:{id:4, pid:2,label:'xx',details:}
        // parents 存的是层级关系。{P1: "P0", P2: "P1", C2: "P2", C4: "P2", P3: "P1"}
        // values 存的是除依据外的指标名称。{P1: "基本情况", P2: "在校生规模", P3: "专业高考报考率"}
        // keys 存的是例如在 parents 与 scores 里依据对应的 key 值。["C2", "C4", "C3"]
        return {
            targetId: response.dataList[0].id,
            targetName: response.dataList[0].label,
            count : response.count ,
            descList : response.descList, 
            // resultState: response.resultState,
            // resultScore : response.resultScore,
            // isAdmin: response.isAdmin,
            // description: response.description,
            scores,
            parents,
            values,
            keys,
            descs,
            choices,
        };
    }).then(response => {
        // 指标与依据直接对应的关系 ["P2", "C2"]
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });
        
        // 指标需要的列数
        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));
        // 指标需要的行数
        var rowsCount = response.keys.length;

        return {
            scores: response.scores,
            values: response.values,
            descs: response.descs,
            choices: response.choices,
            targetId: response.targetId,
            targetName: response.targetName,
            count : response.count ,
            descList : response.descList, 
            // resultState: response.resultState,
            // resultScore : response.resultScore,
            // isAdmin: response.isAdmin,
            // description: response.description,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            })
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;

        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            descs: response.descs,
            choices: response.choices,
            targetId: response.targetId,
            targetName: response.targetName,
            count : response.count ,
            descList : response.descList, 
            // resultState: response.resultState,
            // resultScore : response.resultScore,
            // isAdmin: response.isAdmin,
            // description: response.description,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            })
        };
    })
    .then(response => {
        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();
        
        return {
            // selects: selects,
            scores: response.scores,
            values: response.values,
            descs: response.descs,
            choices: response.choices,
            targetId: response.targetId,
            targetName: response.targetName,
            count : response.count ,
            descList : response.descList, 
            // resultState: response.resultState,
            // resultScore : response.resultScore,
            // isAdmin: response.isAdmin,
            // description: response.description,
            data: response.data,
            columns: reverse,
            loading: false
        };
    });
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    remove,
    getDetailByObjId
}